import { isLocalEnv, isPullRequestEnv } from './environment';

const shouldLogToSentry = () => !isLocalEnv() && !isPullRequestEnv();

export default shouldLogToSentry;
